import { LodgingOptionExportExcelState, LodgingOptionExportExcelActionTypes, LODGING_OPTION_EXPORT_EXCEL_REQUEST, LODGING_OPTION_EXPORT_EXCEL_SUCCESS, LODGING_OPTION_EXPORT_EXCEL_FAILURE } from "store/reducers/lodgingOption/exportExcel/types";

const defaultState: LodgingOptionExportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function exportExcel(state = defaultState, action: LodgingOptionExportExcelActionTypes): LodgingOptionExportExcelState {
  switch (action.type) {
    case LODGING_OPTION_EXPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LODGING_OPTION_EXPORT_EXCEL_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LODGING_OPTION_EXPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};